import React, { useState, useEffect, useRef } from 'react'
import { createPortal } from 'react-dom'
import type { ModalProps } from './Modal.types'
import PropTypes from 'prop-types'
import Button from '../button/Button'
import Icon from '../icon/Icon'
import './modal.scss'

const Modal = ({
  title,
  isOpen,
  size,
  img,
  children,
  buttons,
  hideCloseButton,
  setIsOpen,
}: ModalProps) => {
  const [stateModal, setStateModal] = useState(isOpen)
  const overlayRef = useRef<HTMLDivElement>(null)
  const el = document.createElement('div')
  const open = isOpen ? 'sb-modal--open' : ''

  useEffect(() => {
    setStateModal(isOpen)
  }, [isOpen])

  useEffect(() => {
    if (!document.querySelector('.sb-modal__overlay')) {
      const body = document.querySelector('body')
      body?.appendChild(el)
    }
  }, [el])

  useEffect(() => {
    const onKeyDown = (e: any) => {
      if (e.key === 'Escape') {
        closeModal()
      }
    }
    window.addEventListener('onkeydown', onKeyDown)
    return () => window.removeEventListener('onkeydown', onKeyDown)
  }, [])

  setIsOpen = (value: boolean) => {
    setStateModal(value)
  }

  const closeModal = () => setStateModal(false)

  const handleOverlayClick = (e: any) => {
    if (hideCloseButton || e.target !== overlayRef.current) {
      return
    }
    closeModal()
  }

  if (!stateModal) return null

  return (
    stateModal &&
    createPortal(
      <div
        className={['sb-modal__overlay', `sb-modal--${size}`, open].join(' ')}
        data-testid='sb-modal__overlay'
        ref={overlayRef}
        onClick={handleOverlayClick}
      >
        <div className='sb-modal__container' data-testid='sb-modal__container'>
          {!hideCloseButton && (
            <span
              className='sb-modal__close'
              data-testid='sb-modal__close'
              onClick={closeModal}
            >
              <Icon
                iconName='x'
                size={15}
                style={{ color: 'var(--primary)' }}
              />
            </span>
          )}
          <div className={['sb-modal'].join(' ')} data-testid='sb-modal'>
            {img && img}
            <p className='font-black text-heading-02 mb-lg'>{title}</p>
            {children}
            {buttons && <div className='sb-modal__buttons'>{buttons}</div>}
          </div>
        </div>
      </div>,
      el
    )
  )
}

Modal.propTypes = {
  /**
   * title Modal
   */
  title: PropTypes.string.isRequired,
  /**
   * Modal isOpen?
   */
  isOpen: PropTypes.bool,
  /**
   * Size Modal
   */
  size: PropTypes.oneOf(['sm', 'md']),
  /**
   * Modal img
   */
  img: PropTypes.object,
  /**
   * Modal children
   */
  children: PropTypes.object,
  /**
   * Modal buttons
   */
  buttons: PropTypes.arrayOf(PropTypes.object),
  /**
   * hideCloseButton
   */
  hideCloseButton: PropTypes.bool,
}

Modal.defaultProps = {
  title: 'Actualiza tus datos personales',
  isOpen: true,
  hideCloseButton: false,
  size: 'sm',
  img: (
    <img
      src={
        'https://www.carreras.pe/userfiles/images/Logos%20y%20fachadas/Logo%20UTP%202.png'
      }
      alt='UTP'
      style={{ width: '180px' }}
    />
  ),
  children: (
    <>
      <p className='text-body text-neutral-02'>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
        tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
        veniam.
      </p>
    </>
  ),
  buttons: [
    <Button
      size='sm'
      type='solid'
      className='w-full'
      text='No, regresar'
      color='primary'
      key='button-0'
    />,
  ],
}

export default Modal
